import React, { useEffect, useState } from "react";
import { Container, FormGroup, Input, Label } from "reactstrap";
import { Modal as ModalB, ModalHeader, ModalBody, Button } from "reactstrap";
import { FaSistrix } from "react-icons/fa";
import { FaSearchPlus } from "react-icons/fa"; // ไอคอนแว่นขยาย
import { useNavigate } from "react-router-dom";
import { Loading } from "../share/loading";
import { FiEdit } from "react-icons/fi";
import Modal from "react-modal"
import { Formik, Field, Form } from 'formik';
import CreateTableComponent from "../share/CreateTableComponent";
import { ConvertDateFormat } from "../share/ConvertDateFormat";
import { ConvertDateToThaiBuddhist } from "../share/ConvertDateToThaiBuddhist";
import { RenderCustomHeader } from "../share/RenderCustomHeader";
import { NumberWithCommas } from "../share/NumberWithCommas";
import '../share/TableLanding.css';
import '../share/form.css';
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import '../share/TabStyle.css'
import * as Yup from "yup";
import { IoMdCreate } from "react-icons/io";
import { TiTick } from "react-icons/ti";
import { CgClose } from "react-icons/cg";
import { HiOutlineFolderDownload } from "react-icons/hi";
import { getCustomStyles } from "../share/ModalStyle";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from "../share/CustomInputNumeric";
import { MdDelete } from "react-icons/md";
import SupportDetailModal from "./SupportDetailModal";
import ReportUsingMoneyDetailModal from "./ReportUsingMoneyDetailModal";
export function TableLandingSupportComponent() {

    const navigate = useNavigate();
    const myCustomStyles = getCustomStyles()
    const user = JSON.parse(localStorage.getItem("userData"))
    const [loading, setLoading] = useState(false);
    const [dataSupport, setDataSupport] = useState([]);
    // console.log("dataSupport", dataSupport);
    const [dataSupportId, setDataSupportId] = useState([]);
    const [dataInnovation, setDataInnovation] = useState([]); //แบบขอหลักสูุตรนวัตกรรม
    const [dataAssessment, setDataAssessment] = useState([]); //ชอ3
    const [modalTransferPromotion, setModalTransferPromotion] = useState(false);
    const toggleModalTransferPromotion = () => setModalTransferPromotion(!modalTransferPromotion);
    const [selectedSupportId, setSelectedSupportId] = useState(null);

    const [openModalForm, setOpenModalForm] = useState(false)
    const toggleModalForm = () => setOpenModalForm(!openModalForm);
    const [idExportSupportForm, setIdExportSupportForm] = useState({
        supportId: "",
        supportTypeId: "",
    })
    const [showModalExportSupportForm, setShowModalExportSupportForm] = useState(false);
    const ToggleModalExportSupportForm = () => setShowModalExportSupportForm(!showModalExportSupportForm);

    const [considerResultReport, setConsiderResultReport] = useState([]);
    const [reportUsingMoney, setReportUsingMoney] = useState([]);
    const [certAndProjectReportUsingMoney, setCertAndProjectReportUsingMoney] = useState([]);
    // console.log("certAndProjectReportUsingMoney", certAndProjectReportUsingMoney);
    // console.log("reportUsingMoney", reportUsingMoney);
    const [openRemark, setOpenRemark] = useState(false);
    const ToggleModalOpenRemark = () => setOpenRemark(!openRemark);

    const [dataRemark, setDataRemark] = useState("");

    const requestDeleteSupportId = async (supportId) => {
        // console.log("supportId", supportId);
        Swal.fire({
            icon: "warning",
            title: "ยืนยันการลบข้อมูลหรือไม่ ?",
            text: "",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let postData = new FormData();
                    postData.append("supportId", Number(supportId));
                    let res = await fetch("/api/Support/deleteSupport", {
                        method: "POST",
                        body: postData,
                    });

                    let resJson = await res.json();
                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "ลบข้อมูลสำเร็จ",
                            text: "",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            window.location.reload();
                        });
                    }
                } catch (e) {

                }
            }
            // window.location.reload();
        });

    }
    const DeleteSupport = ({ supportId }) => {
        return <MdDelete className="mx-3 style-icon" onClick={(e) => requestDeleteSupportId(supportId)} />
    }
    //ดึงข้อมูลคำขอรับเงินช่วยเหลือหรืออุดหนุน
    useEffect(() => {
        async function getSupportDataByRold() {
            setLoading(true);
            if (user.roldId === "1" || user.roldId === "2") {
                let postData = new FormData();
                postData.append("registerId", user.registerId);
                try {
                    let res = await fetch("/api/Support/getSupportNormalUser", {
                        method: "POST",
                        body: postData,
                    });

                    const data = await res.json();
                    setDataSupport(data.dataenum);
                } catch (e) {
                    // console.log("err", e)
                } finally {
                    setLoading(false)
                }

            } else if (user.roldId === "3") {
                let postData = new FormData();
                postData.append("deptId", user.deptId);
                try {
                    let res = await fetch("/api/Support/getSupportByOfficer", {
                        method: "POST",
                        body: postData,
                    });
                    const data = await res.json();
                    setDataSupport(data.dataenum);
                } catch (e) {
                    // console.log(e)
                } finally {
                    setLoading(false)
                }

            } else if (user.roldId === "4") {
                try {
                    let res = await fetch("/api/Support/getSupportByPromotion");
                    const data = await res.json();
                    setDataSupport(data.dataenum);
                } catch (e) {
                    // console.log(e)
                } finally {
                    setLoading(false)
                }
            }
        }
        getSupportDataByRold()
    }, [])

    //ดึงข้อมูลคำขอรับเความเห็นชอบหลักสูตรนวัตกรรม
    useEffect(() => {
        const getSupportInnovationData = async () => {
            setLoading(true)
            if (user.roldId === "1" || user.roldId === "2") {
                try {
                    let postData = new FormData();
                    postData.append("registerId", user.registerId);
                    let res = await fetch("/api/Support/getSupportInnovationNormalUser", {
                        method: "POST",
                        body: postData,
                    });

                    const data = await res.json();
                    setDataInnovation(data.dataenum);
                } catch (e) {
                    // console.log("err", e)
                } finally {
                    setLoading(false)
                }
            } else if (user.roldId === "3") {
                try {
                    let postData = new FormData();
                    postData.append("deptId", user.deptId);
                    let res = await fetch("/api/Support/getSupportInnovationByOfficer", {
                        method: "POST",
                        body: postData,
                    });
                    let data = await res.json();
                    setDataInnovation(data.dataenum);
                } catch (e) {
                    // console.log(e)
                } finally {
                    setLoading(false)
                }
            }
        }
        getSupportInnovationData();
    }, [])

    //ดึงข้อมูลการนำส่ง ชอ 3
    useEffect(() => {
        async function getAssessment() {
            setLoading(true)
            if (user.roldId === "1" || user.roldId === "2") {
                try {
                    let res = await fetch("/api/Support/getAssessmentUser", {
                        method: "POST",
                        headers: {
                            // 'Content-type': 'application/json',
                            'token': user.token
                        }
                    });
                    let data = await res.json();
                    setDataAssessment(data.dataenum);
                } catch (e) {
                    // console.log(e)
                } finally {
                    setLoading(false)
                }
            }
            if (user.roldId === "3") {
                try {
                    let res = await fetch("/api/Support/getAssessmentOfficer", {
                        method: "POST",
                        headers: {
                            // 'Content-type': 'application/json',
                            'token': user.token
                        }
                    });
                    let data = await res.json();
                    setDataAssessment(data.dataenum);
                } catch (e) {
                    // console.log(e)
                } finally {
                    setLoading(false)
                }
            } else if (user.roldId === "4") {
                try {
                    let res = await fetch("/api/Support/getAssessmentPromotion");
                    const data = await res.json();
                    setDataAssessment(data.dataenum);
                } catch (e) {
                    // console.log(e)
                } finally {
                    setLoading(false)
                }
            }
        }
        getAssessment()
    }, [])

    //ดึงรายงาน ชอ.4-1 ถึง 4-7
    useEffect(() => {
        GetConsiderReportResult(); //ดึงรายงาน ชอ.4-1 ถึง 4-7
        GetReportUsingMoney(); //ดึงรายงาน ชอ.4-8, 4-9
    }, [])

    const GetConsiderReportResult = async () => {
        setLoading(true);
        try {
            let res = await fetch("/api/Support/considerReportResult", {
                method: "POST",
                headers: {
                    "token": user.token,
                    'Content-type': 'application/json'
                },
            })
            let resJson = await res.json();
            // console.log("resJson", resJson.dataenum);
            setConsiderResultReport(resJson.dataenum);
        } catch (e) {

        } finally {
            setLoading(false);
        }
    }

    function groupReportData(data) {

        const map = new Map();

        data.forEach(item => {
            const id = item.id; // ใช้ id เป็น key สำหรับ group

            if (!map.has(id)) {
                map.set(id, {
                    ...item,
                    occupations: new Set(), // เก็บสาขาแบบ unique
                });
            }

            const target = map.get(id);

            // ===== รวมสาขาอาชีพแบบ unique =====
            let occ = item.lawOccupationName || "";

            // เติมสาขาย่อย testOccupationName หรือ courseName
            if (item.testOccupationName) {
                occ += ` สาขา ${item.testOccupationName}`;
            } else if (item.courseName) {
                occ += ` โครงการ ${item.courseName}`;
            }

            if (occ.trim() !== "") {
                target.occupations.add(occ);
            }
        });

        // แปลง Set กลับเป็น array/string
        return Array.from(map.values()).map(v => ({
            ...v,
            occupations: Array.from(v.occupations).join(", "),
        }));
    }

    //ดึงรายงาน ชอ.4-8, 4-9
    const GetReportUsingMoney = async () => {
        setLoading(true);
        try {
            let res = await fetch("/api/Support/reportUsingMoney", {
                method: "POST",
                headers: {
                    "token": user.token,
                    'Content-type': 'application/json'
                },
            })
            let resJson = await res.json();
            // console.log("resJson", resJson.dataenum);
            // ⭐ Group by id + merge occupations
            const filteredA = resJson.dataenum.filter(
                item => item.typeReport == '47' || item.typeReport == '48' || item.typeReport == '410'
            );
    
            const filteredB = resJson.dataenum.filter(
                item => item.typeReport == '49' || item.typeReport == '411'
            );

            setReportUsingMoney(groupReportData(filteredA));
            setCertAndProjectReportUsingMoney(groupReportData(filteredB));
            //setReportUsingMoney(resJson.dataenum.filter(item => item.typeReport == '47' || item.typeReport == '48' || item.typeReport == '410'));
            //setCertAndProjectReportUsingMoney(resJson.dataenum.filter(item => item.typeReport == '49' || item.typeReport == '411'))
        } catch (e) {

        } finally {
            setLoading(false);
        }
    }

    const ShowGetRemark = () => {
        return (
            <Modal
                isOpen={openRemark}
                onRequestClose={ToggleModalOpenRemark}
                style={myCustomStyles}
            >
                <div className="d-flex justify-content-between align-items-center w-100">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}>รายการที่ต้องดำเนินการแก้ไข</h3>
                    <CgClose onClick={ToggleModalOpenRemark} className="style-iconmodal" />
                </div>
                <hr />
                <div className="mt-3 w-100">
                    <Label>
                        ความคิดเห็นสำหรับเจ้าหน้าที่ สพร./ สนพ.
                    </Label>
                    <div
                        className="border border-1"
                        style={{ minHeight: "3rem" }}
                    >
                        <span className="input-color mx-1">{dataRemark}</span>
                    </div>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                    <button
                        type="button"
                        style={{ backgroundColor: "#0A66C2", color: "#fff" }}
                        className="btn border border-1 w-25 rounded-pill mt-3"
                        onClick={ToggleModalOpenRemark}>
                        ย้อนกลับ
                    </button>
                </div>

            </Modal>

        )
    };
    //รายการแบบฟอร์มขอรับเงินช่วยเหลือหรืออุดหนุน
    const ListFormForSelect = () => {

        const supportFormOfficer = [
            {
                path: "create-support-announce4?req=0",
                label: "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน",
                announce: "ประกาศข้อ 4",
                supportTypeId: [1]
            },
            {
                path: "create-support-announce10?req=0",
                label: "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน",
                announce: "ประกาศข้อ 10",
                supportTypeId: [3]
            },
            {
                path: "create-support-announce10Estimate?req=0",
                label: "ศูนย์ประเมินความรู้ความสามารถ ตามมาตรา ๒๖/๔ (๒)",
                announce: "ประกาศข้อ 10",
                supportTypeId: [9]
            },
            {
                path: "create-support-announce5?req=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 5",
                supportTypeId: [2]
            },
            {
                path: "create-support-announce6?req=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 6",
                supportTypeId: [4]
            },
            {
                path: "create-support-announce7?req=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 7",
                supportTypeId: [5]
            },
            {
                path: "create-support-announce8?req=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 8",
                supportTypeId: [6]
            },
            // {
            //     path: "DetailSupportFormForEntrepreneurAnnounce9?req=0&type=0",
            //     label: "ผู้ประกอบกิจการ",
            //     announce: "ประกาศข้อ 8",
            //     supportTypeId: [7]
            // },
            {
                path: "create-support-announce9?req=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 9",
                supportTypeId: [8]
            },

        ]

        const supportFormMap = {
            1: {
                path: "DetailSupportFormForTest?req=0&type=1",
                label: "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน",
                announce: "ประกาศข้อ 4",
                supportTypeId: [1]
            },
            2: {
                path: "DetailSupportFormForTest?req=0&type=2",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 5",
                supportTypeId: [2]
            },
            3: {
                path: "DetailSupportFormForTest?req=0&type=3",
                label: "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน",
                announce: "ประกาศข้อ 10",
                supportTypeId: [3]
            },
            4: {
                path: "DetailSupportFormForEntrepreneurAnnounce6?req=0&type=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 6",
                supportTypeId: [4]
            },
            5: {
                path: "DetailSupportFormForEntrepreneurAnnounce7?req=0&type=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 7",
                supportTypeId: [5]
            },
            6: {
                path: "DetailSupportFormForEntrepreneurAnnounce8?req=0&type=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 8",
                supportTypeId: [6]
            },
            // 7: {
            //     path: "DetailSupportFormForEntrepreneurAnnounce9?req=0&type=0",
            //     label: "ผู้ประกอบกิจการ",
            //     announce: "ประกาศข้อ 9",
            //     supportTypeId: [7]
            // },
            8: {
                path: "DetailSupportFormForEntrepreneurAnnounce10Ch24?req=0&type=0",
                label: "ผู้ประกอบกิจการ",
                announce: "ประกาศข้อ 9",
                supportTypeId: [8]
            },
            9: {
                path: "EstimateAnnounce11Form?req=0&type=0",
                label: "ศูนย์ประเมินความรู้ความสามารถ",
                announce: "ประกาศข้อ 10",
                supportTypeId: [9]
            }
        };

        const [availableForms, setAvailableForms] = useState([]);

        const filterAccessSupportForm = (objectAccess) => {
            return objectAccess.filter(x => x.canAccess === "Y").map(x => x.supportTypeId);
        }

        const fetchAccessForms = async () => {
            if (user.roldId !== "3") {
                try {
                    const res = await fetch("/api/Support/accessSupportForm", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            token: user.token
                        }
                    });
                    const resJson = await res.json();

                    const grantedAccessIds = filterAccessSupportForm(resJson.dataenum);
                    const uniqueSupportIds = [...new Set(grantedAccessIds)];

                    if (user.roldId !== "3") {
                        const formArray = Object.values(supportFormMap);

                        const matchedForms = formArray.filter(form =>
                            form.supportTypeId.some(id => uniqueSupportIds.includes(id))
                        );

                        setAvailableForms(matchedForms);
                    }
                } catch (err) {
                    console.error("Fetch error", err);
                    Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถโหลดข้อมูลแบบฟอร์มได้", "error");
                }
            }
        };

        useEffect(() => {
            if (openModalForm) {
                fetchAccessForms();
            }
        }, [openModalForm]);

        return (
            <Modal
                isOpen={openModalForm}
                onRequestClose={toggleModalForm}
                style={myCustomStyles}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "1440px", width: "100%" }}>เลือกรายการ</h3>
                    <CgClose onClick={toggleModalForm} className="style-iconmodal" />
                </div>
                <hr />

                {user.roldId !== "3" ? (
                    <div className="grid gap-3 justify-content-center"
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                            maxWidth: "1024px",
                            margin: "0 auto",
                        }}
                    >
                        {availableForms.length > 0 ? (
                            availableForms.map((form, index) => (
                                <button
                                    key={index}
                                    className="modal-select"
                                    style={{
                                        maxWidth: "320px",
                                        width: "100%",
                                        padding: "1rem",
                                        borderRadius: "10px",
                                        border: "1px solid #0E527E",
                                        backgroundColor: "#ffffff",
                                        color: "#0E527E",
                                        transition: "all 0.3s",
                                    }}
                                    onClick={() => navigate(`/supporting/Form/${form.path}`)}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#0E527E"}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#ffffff"}
                                    onFocus={(e) => e.currentTarget.style.outline = "none"}
                                >
                                    <div style={{ fontWeight: "bold" }}>{form.label}</div>
                                    <small>{form.announce}</small>
                                </button>
                            ))
                        ) : (
                            <p className="text-danger mt-3">คุณไม่มีสิทธิ์เข้าถึงแบบฟอร์มใด ๆ</p>
                        )}
                    </div>
                ) : (
                    <div className="grid gap-3 justify-content-center"
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                            maxWidth: "1024px",
                            margin: "0 auto",
                        }}
                    >
                        {supportFormOfficer.length > 0 ? (
                            supportFormOfficer.map((form, index) => (
                                <button
                                    key={index}
                                    className="modal-select"
                                    style={{
                                        maxWidth: "320px",
                                        width: "100%",
                                        padding: "1rem",
                                        borderRadius: "10px",
                                        border: "1px solid #0E527E",
                                        backgroundColor: "#ffffff",
                                        color: "#0E527E",
                                        transition: "all 0.3s",
                                    }}
                                    onClick={() => navigate(`/supporting/Form/${form.path}`)}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#0E527E"}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#ffffff"}
                                    onFocus={(e) => e.currentTarget.style.outline = "none"}
                                >
                                    <div style={{ fontWeight: "bold" }}>{form.label}</div>
                                    <small>{form.announce}</small>
                                </button>
                            ))
                        ) : (
                            <p className="text-danger mt-3">คุณไม่มีสิทธิ์เข้าถึงแบบฟอร์มใด ๆ</p>
                        )}
                    </div>
                )}

            </Modal>
        )
    }


    //ปุ่มแบบฟอร์มขอรับเงินช่วยเหลือหรืออุดหนุน
    const FormButton = () => {
        if (user.roldId === "1" || user.roldId === "2" || user.roldId === "3") {
            return (
                <button
                    className="btn-blue create-button-form"
                    onClick={() => toggleModalForm()}
                >
                    <IoMdCreate className="mx-2" />
                    สร้างแบบคำขอรับเงินช่วยเหลือหรืออุดหนุน
                </button>
            )
        } else {
            <></>
        }
    }

    //ปุ่มแบบฟอร์มคำขอรับความเห็นชอบหลักสูตรนวัตกรรม ขร.1
    const FormInnovationButton = () => {
        if (user.roldId === "1" || user.roldId === "2") {
            return (
                <button
                    className="btn-blue create-button-form"
                    onClick={() => navigate(`/supporting/Form/DetailSupportFormForEntrepreneurInnovationAnnounce10?req=0&&status=0`)}
                >
                    <IoMdCreate className="mx-2" />
                    สร้างแบบคำขอรับความเห็นชอบหลักสูตรนวัตกรรม ขร.1
                </button>
            )
        } else {
            <div className="m-0"></div>
        }
    }

    //กรอกแบบ ชอ3 ตาม supportTypeId ของแต่ละ support
    const openOperationReport = (supportId, typeId) => {

        if (typeId === "1" || typeId === "3") { // ประกาศ 4 10
            navigate(`/supporting/operation/OperationReport3?req=${supportId}`) //3 เอกสาร
        } else if (typeId === "9") { // ประกาศ 11 ศูนย์ประเมินความรู้ความสามารถ
            navigate(`/supporting/operation/OperationReport32?req=${supportId}`) //3-1 เอกสาร
        } else {
            navigate(`/supporting/operation/OperationReport31?req=${supportId}`) //3-2 เอกสาร
        }

    }

    //กรอกแบบ ชอ3 ตาม supportTypeId ของแต่ละ support
    const openEditSupportForm = (supportId, typeId) => {
        if (typeId === "1" || typeId === "2" || typeId === "3") { // ประกาศ 4 5 11
            navigate(`/supporting/Form/DetailSupportFormForTest?req=${supportId}&type=${typeId}`)
        } else if (typeId === "4") { // ประกาศ 6
            navigate(`/supporting/Form/DetailSupportFormForEntrepreneurAnnounce6?req=${supportId}&type=${typeId}`)
        } else if (typeId === "5") { // ประกาศ 7
            navigate(`/supporting/Form/DetailSupportFormForEntrepreneurAnnounce7?req=${supportId}&type=${typeId}`)
        } else if (typeId === "6") { // ประกาศ 8
            navigate(`/supporting/Form/DetailSupportFormForEntrepreneurAnnounce8?req=${supportId}&type=${typeId}`)
        } else if (typeId === "7") { // ประกาศ 9
            navigate(`/supporting/Form/DetailSupportFormForEntrepreneurAnnounce9?req=${supportId}&type=${typeId}`)
        } else if (typeId === "8") { // ประกาศ 10
            navigate(`/supporting/Form/DetailSupportFormForEntrepreneurAnnounce10Ch24?req=${supportId}&type=${typeId}`)
        } else if (typeId === "9") { // ประกาศ 10
            navigate(`/supporting/Form/EstimateAnnounce11Form?req=${supportId}&type=${typeId}`)
        }
    }

    // export เอกสารแบบฟอร์มชอรับเงินช่วยเหลือหรืออุดหนุน
    const ModalExportSupportAnnounce9 = () => {
        return (
            <Modal
                isOpen={showModalExportSupportForm}
                onRequestClose={ToggleModalExportSupportForm}
                style={myCustomStyles}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "700px", width: "100%" }}>เลือกรายการ</h3>
                    <CgClose onClick={ToggleModalExportSupportForm} className="style-iconmodal" />
                </div>
                <hr />
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="button"
                        style={{ maxWidth: "320px", width: "100%" }}
                        className="modal-select"
                        onClick={() => window.open(`api/SupportReports/export/exportSupportForm?supportId=${Number(idExportSupportForm.supportId)}&supportTypeId=${Number(idExportSupportForm.supportTypeId)}`)}
                    >
                        คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน

                    </button>
                    <button
                        type="button"
                        style={{ maxWidth: "320px", width: "100%" }}
                        className="modal-select"
                        onClick={() => window.open(`api/SupportReports/export/listEmployee?supportId=${Number(idExportSupportForm.supportId)}&type=${1}`)}
                    >
                        แบบสรุปรายชื่อลูกจ้างที่ส่งเข้ารับการทดสอบและผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติและจ่ายค่าจ้างตามมาตรฐานฝีมือ

                    </button>
                    <button
                        type="button"
                        style={{ maxWidth: "320px", width: "100%" }}
                        className="modal-select"
                        onClick={() => window.open(`api/SupportReports/export/listEmployee?supportId=${Number(idExportSupportForm.supportId)}&type=${2}`)}
                    >
                        แบบสรุปรายชื่อลูกจ้างที่ส่งเข้ารับการทดสอบและผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติและจ่ายค่าจ้างตามมาตรฐานฝีมือ

                    </button>


                </div>
            </Modal>
        )


    }

    //export แบบฟอร์มขอรับเงินช่วยเหลือหรืออุดหนุน
    const ExportSupportForm = (supportId, supportTypeId) => {
        setIdExportSupportForm({
            supportId: supportId,
            supportTypeId: supportTypeId
        });
        if (supportTypeId === "7") {
            ToggleModalExportSupportForm()
        } else {
            window.open(`api/SupportReports/export/exportSupportForm?supportId=${Number(supportId)}&supportTypeId=${Number(supportTypeId)}`)
        }
    }

    //ปุ่ม export ที่ใช้ tooltip
    const CallExportSupportForm = React.forwardRef((props, ref) => {
        const { supportId, supportTypeId } = props;
        return (
            <div ref={ref} style={{ display: "inline" }}>
                <HiOutlineFolderDownload
                    className="mx-1 style-icon"
                    onClick={() => {
                        ExportSupportForm(supportId, supportTypeId)
                    }}
                />
            </div>
        );
    });

    // ---------------------------------------------------------------------------
    //function สำหรับรับทราบ ชอ.4
    const AcceptConsiderReport = async (supportId) => {
        // console.log("supportId", supportId);
        try {
            let postData = new FormData();
            postData.append("supportId", supportId);
            let res = await fetch("/api/Support/approveConsiderReport", {
                method: "POST",
                body: postData
            });
            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    GetConsiderReportResult();
                });
            }
        } catch (e) {

        }
    }

    //function สำหรับรับทราบ ชอ.4
    const AcceptConsiderReportUsingMoney = async (id, type) => {
        // console.log("supportId", supportId);
        try {
            let postData = new FormData();
            postData.append("id", Number(id));
            postData.append("type", type);

            let res = await fetch("/api/Support/approveConsiderReportUsingMoney", {
                method: "POST",
                body: postData
            });
            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    GetConsiderReportResult();
                });
            }
        } catch (e) {

        }
    }

    const CallAcceptConsiderReport = React.forwardRef((props, ref) => {
        const { supportId } = props;
        return (
            <div ref={ref} style={{ display: "inline" }}>
                <TiTick
                    className="mx-1 ms-2 style-icon"
                    onClick={() => {
                        AcceptConsiderReport(supportId)
                    }}
                />
            </div>
        );
    });

    const CallAcceptConsiderReportUsingMoney = React.forwardRef((props, ref) => {
        const { id, type } = props;
        return (
            <div ref={ref} style={{ display: "inline" }}>
                <TiTick
                    className="mx-1 ms-2 style-icon"
                    onClick={() => {
                        AcceptConsiderReportUsingMoney(id, type)
                    }}
                />
            </div>
        );
    });
    // ---------------------------------------------------------------------------
    //แสดงคำขอรับเงินช่วยเหลือหรืออุดหนุนตามประเภทของ user 
    const ShowInfoSupportByUsers = () => {
        if (user.roldId === "1" || user.roldId === "2") {

            const COLUMNS = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1
                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",
                },
                {
                    Header: "จำนวนเงิน (บาท)",
                    accessor: a => (a.amount ? a.amount : "-"),
                    Cell: ({ value }) => { return <>{NumberWithCommas(value)}</> }

                },
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "supportId"
                },
                {
                    Header: "สถานะ",
                    accessor: "supportStatusName",
                    Cell: ({ value, row }) => {
                        if (row.original.supportStatusId === "10" || row.original.supportStatusId === "13" || row.original.supportStatusId === "18") {
                            if (row.original.supportAssessment === "0") {
                                return (
                                    <>
                                        {value}
                                        <FiEdit
                                            className="mx-3 style-icon"
                                            onClick={() => { openOperationReport(row.original.supportId, row.original.supportTypeId) }}
                                        />
                                        <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                            <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                        </Tippy>
                                    </>
                                )
                            } else {
                                return (
                                    <>
                                        {value}
                                        <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                            <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                        </Tippy>
                                    </>
                                )
                            }
                        } else if (row.original.supportStatusId === "4") { //แก้ไข
                            return (
                                <>
                                    {value}
                                    <FiEdit
                                        className="mx-3 style-icon"
                                        onClick={() => { openEditSupportForm(row.original.supportId, row.original.supportTypeId) }}
                                    />

                                    <FaSistrix className="mx-1 style-icon"
                                        onClick={async () => {
                                            await setDataRemark(row.original.note);
                                            await ToggleModalOpenRemark();
                                        }}
                                    />
                                </>
                            )
                        } else if (row.original.supportStatusId === "28") {
                            return <div className="text-danger">
                                {row.original.supportStatusName}
                            </div>
                        } else {
                            return <>
                                {row.original.supportStatusName}
                                <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                    <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                </Tippy>
                            </>
                        }
                    }
                },

            ];
            return COLUMNS;
        } else if (user.roldId === "3") {
            const COLUMNS = [
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "supportId"
                },

                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",

                },
                {
                    Header: "ชื่อ",
                    accessor: "supportName",
                    Cell: ({ value }) => { return <div className="text-left">{(value)}</div> }


                },
                {
                    Header: "จำนวนเงิน (บาท)",
                    accessor: a => (a.amount ? a.amount : "-"),
                    Cell: ({ value }) => { return <>{NumberWithCommas(value)} </> }

                },
                {
                    Header: "เลขที่คำขอ",
                    accessor: "supportNo",
                    Cell: ({ value }) => {
                        if (value === null) {
                            return (
                                <>-</>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "เจ้าหน้าที่ที่ตรวจสอบ",
                    accessor: "officerApproveBy",
                    Cell: ({ value }) => {
                        if (value === null) {
                            return (
                                <>-</>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "ผู้อำนวยการที่ตรวจสอบ",
                    accessor: "directorApproveBy",
                    Cell: ({ value }) => {
                        if (value === null) {
                            return (
                                <>-</>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "สถานะ",
                    accessor: "supportStatusName",
                    Cell: ({ value, row }) => {

                        if (row.original.supportStatusId === "2" || row.original.supportStatusId === "7") {
                            return (
                                <>
                                    {value}
                                    <FaSistrix className="mx-1 style-icon"
                                        onClick={() => navigate(`/supporting/admin/Check?req=${row.original.supportId}`)}
                                    />
                                    {/* <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                        <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                    </Tippy> */}
                                </>
                            )
                        } else if (row.original.supportStatusId === "6" || row.original.supportStatusId === "10" || row.original.supportStatusId === "25") {
                            return (
                                <>
                                    {value}
                                    <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                        <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                    </Tippy>
                                </>
                            )
                        } else if (row.original.supportStatusId === "15") {
                            return (
                                <>
                                    {value}
                                    <FiEdit
                                        className="mx-3 style-icon"
                                        onClick={() => { showFormTransfer(row.original.supportId) }}
                                    />
                                    <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                        <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                    </Tippy>
                                </>
                            )
                        } else {
                            return <>{value}</>
                        }
                    }
                },

            ];
            return COLUMNS;
        } else if (user.roldId === "4") {

            const COLUMNS = [
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "supportId"
                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",
                },
                {
                    Header: "ชื่อ",
                    accessor: "supportName",
                    Cell: ({ value }) => { return <div className="text-left">{(value)}</div> }

                },
                {
                    Header: "จำนวนเงิน (บาท)",
                    accessor: a => (a.amount ? a.amount : "-"),
                    Cell: ({ value }) => { return NumberWithCommas(value) }

                },
                {
                    Header: "เลขที่คำขอ",
                    accessor: "supportNo",
                    Cell: ({ value }) => {
                        if (value === null) {
                            return (
                                <>-</>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "เจ้าหน้าที่ที่ตรวจสอบ",
                    accessor: "officerApproveBy",
                    Cell: ({ value }) => {
                        if (value === null) {
                            return (
                                <>-</>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "ผู้อำนวยการที่ตรวจสอบ",
                    accessor: "directorApproveBy",
                    Cell: ({ value }) => {
                        if (value === null) {
                            return (
                                <>-</>
                            )
                        } else {
                            return (
                                <>{value}</>
                            )
                        }
                    }
                },
                {
                    Header: "สถานะ",
                    accessor: "supportStatusName",
                    Cell: ({ value, row }) => {
                        if (row.original.supportStatusId === "6") {
                            return (
                                <>
                                    {value}
                                    <FiEdit
                                        className="mx-3 style-icon"
                                        onClick={() => { showFormTransfer(row.original.supportId) }}
                                    />
                                    <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                        <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                    </Tippy>
                                    <FaSistrix className="mx-1 style-icon"
                                        onClick={() => navigate(`/supporting/admin/Check?req=${row.original.supportId}`)}
                                    />
                                    <DeleteSupport supportId={row.original.supportId} />
                                </>
                            )
                        } else if (row.original.supportStatusId === "10" || row.original.supportStatusId === "13" || row.original.supportStatusId === "15") {
                            return (
                                <>
                                    {value}
                                    <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                        <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                    </Tippy>
                                    <DeleteSupport supportId={row.original.supportId} />

                                </>
                            )
                        } else {
                            return (
                                <>
                                    {row.original.supportStatusName}
                                    <DeleteSupport supportId={row.original.supportId} />

                                </>
                            )
                        }
                    }
                },

            ];
            return COLUMNS;
        }

    }

    // แสดงคำขอรับความเห็นชอบหลักสูตรนวัตกรรมตามประเภทของ user
    const ShowInfoInnovationByUsers = () => {

        if (user.roldId === "1" || user.roldId === "2") {

            const COLUMNSINNOVATION = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1
                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",

                },
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "supportInnovationId"
                    // accessor:"supportId"
                },
                {
                    Header: "สถานะ",
                    accessor: "supportStatusInnovationName",
                    Cell: ({ row, value }) => {
                        return (
                            <>
                                {value}
                                {row.original.supportStatusInnovationId === "1" ? (
                                    <FiEdit
                                        className="mx-3 style-icon"
                                        onClick={() =>
                                            navigate(
                                                `/supporting/Form/DetailSupportFormForEntrepreneurInnovationAnnounce10?req=${row.original.supportInnovationId}&status=${row.original.supportStatusInnovationId}`
                                            )
                                        }
                                    />
                                ) : null}

                            </>
                        )
                    }
                },
            ]
            return COLUMNSINNOVATION;

        } else if (user.roldId === "3") {

            const COLUMNSINNOVATION = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1
                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",

                },
                {
                    Header: "ชื่อผู้ขอรับความเห็นชอบหลักสูตรนวัตกรรมฯ",
                    accessor: "supportInnovationName"
                    // accessor:"supportId"
                },
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "supportInnovationId"
                    // accessor:"supportId"
                },
                {
                    Header: "สถานะ",
                    accessor: "supportStatusInnovationName",
                    Cell: ({ row, value }) => {
                        return (
                            <>
                                {value}
                                {row.original.supportStatusInnovationId === "14" ? (
                                    <FaSistrix
                                        className="mx-3 style-icon"
                                        onClick={() => { navigate(`/supporting/support/ApproveInnovationAnnouce10?req=${row.original.supportInnovationId}`) }}
                                    />
                                ) : null}

                            </>
                        )
                    }
                },

            ]
            return COLUMNSINNOVATION;

        }
    }

    // แสดงรายการแบบรายงานการดำเนินการ ชอ 3 ทั้งหมด
    const ShowInfoAssessmentByUsers = () => {

        if (user.roldId === "1" || user.roldId === "2") {

            const COLUMNSASSESSMENT = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1
                },
                {
                    Header: "วันที่ยื่นคำขอ",
                    accessor: "createDate",
                },

                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "supportId"
                },
                {
                    Header: "สถานะ",
                    accessor: "supportStatusName",
                    Cell: ({ row, value }) => {
                        if (row.original.supportStatusId === "10" || row.original.supportStatusId === "13" || row.original.supportStatusId === "18") {
                            if (row.original.supportAssessment === "0") {
                                return (
                                    <>
                                        {value}
                                        <FiEdit
                                            className="mx-3 style-icon"
                                            onClick={() => { openOperationReport(row.original.supportId, row.original.supportTypeId) }}
                                        />
                                        {/* <Tippy content="ดาวน์โหลดเอกสารขอรับเงินช่วยเหลือหรืออุดหนุน">
                                            <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} />
                                        </Tippy> */}
                                    </>
                                )
                            } else {
                                return (
                                    <>
                                        {value}
                                        <Tippy content="ดาวน์โหลดเอกสาร ชอ.3">
                                            <HiOutlineFolderDownload
                                                className="mx-1 style-icon"
                                                onClick={() => {
                                                    window.open("/api/Support/export/assessment/ " + row.original.supportId)
                                                }}
                                            />
                                        </Tippy>

                                    </>
                                )
                            }
                        }
                    }
                },
            ]
            return COLUMNSASSESSMENT;

        } else if (user.roldId === "3") {

            const COLUMNSASSESSMENT = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1
                },
                {
                    Header: "ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน",
                    accessor: "supportName",
                    Cell: ({ row, value }) => {
                        return (
                            <div className="text-start">
                                {value}
                            </div>
                        )
                    }
                },
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "supportId"
                },
                {
                    Header: "สถานะ",
                    accessor: "status",
                    Cell: ({ row, value }) => {
                        // console.log("status", value);
                        // console.log("row", row.original.statusForTest);

                        return (
                            <div className="text-start">
                                {value}
                                {/* {row.original.statusForTest === "1" ? (
                                    <FaSistrix
                                        className="mx-3 style-icon"
                                        onClick={() => { navigate(`/supporting/operation/AdminCheck?req=${row.original.supportId}`) }}
                                    />
                                ) : null} */}
                                {row.original.statusForTest !== "0" ? (
                                    <>
                                        <FaSistrix
                                            className="mx-3 style-icon"
                                            onClick={() => { navigate(`/supporting/operation/AdminCheck?req=${row.original.supportId}&status=${row.original.statusForTest}`) }}
                                        />
                                        <Tippy content="ดาวน์โหลดเอกสาร ชอ.3">
                                            <HiOutlineFolderDownload
                                                className="mx-1 style-icon"
                                                onClick={() => {
                                                    window.open("/api/Support/export/assessment/ " + row.original.supportId)
                                                }}
                                            />
                                            {/* <CallExportSupportForm supportId={row.original.supportId} supportTypeId={row.original.supportTypeId} /> */}
                                        </Tippy>
                                    </>

                                ) : null}

                            </div>
                        )
                    }
                },
            ]
            return COLUMNSASSESSMENT;

        } else if (user.roldId === "4") {

            const COLUMNSASSESSMENT = [
                {
                    Header: "ลำดับ",
                    accessor: (_row, i) => i + 1
                },
                {
                    Header: "ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน",
                    accessor: "supportName",
                    Cell: ({ row, value }) => {
                        return (
                            <div className="text-start">
                                {value}
                            </div>
                        )
                    }
                },
                {
                    Header: "เลขที่อ้างอิง",
                    accessor: "supportId"
                },
                {
                    Header: "สถานะ",
                    accessor: "status",
                    Cell: ({ row, value }) => {
                        return (
                            <div className="text-start">
                                {value}
                                {row.original.statusForTest === "2" ? (
                                    <FaSistrix
                                        className="mx-3 style-icon"
                                        onClick={() => { navigate(`/supporting/operation/AdminCheck?req=${row.original.supportId}&status=${row.original.statusForTest}`) }}
                                    />
                                ) :
                                    <>
                                        <Tippy content="ดาวน์โหลดเอกสาร ชอ.3">
                                            <HiOutlineFolderDownload
                                                className="mx-1 style-icon"
                                                onClick={() => {
                                                    window.open("/api/Support/export/assessment/ " + row.original.supportId)
                                                }}
                                            />
                                        </Tippy>
                                        <FaSistrix
                                            className="mx-3 style-icon"
                                            onClick={() => { navigate(`/supporting/operation/AdminCheck?req=${row.original.supportId}&status=${row.original.statusForTest}`) }}
                                        />
                                    </>

                                }
                            </div>
                        )
                    }
                },
            ]
            return COLUMNSASSESSMENT;
        }
    }

    const [open, setOpen] = useState(false);
    const [supportId, setSupportId] = useState(null);
    const [supportTypeId, setSupportTypeId] = useState(null);

    const openModal = (id, typeId) => {

        setSupportId(id);
        setSupportTypeId(typeId);
        setOpen(true);
    };

    // ====== ส่วน state และ modal สำหรับดูรายละเอียด ======
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const toggleModal = () => setModalOpen(!modalOpen);
    const handleShowDetail = (row) => {
        setSelectedRow(row);
        setModalOpen(true);
    };

    //แสดงรายการ ชอ4
    const considerResultReportColumn = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1
        },
        {
            Header: "ชื่อหน่วยงาน",
            accessor: "deptName",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        {value}
                    </div>
                )
            }
        },
        {
            Header: "ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน",
            accessor: "supportName",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        {value}
                    </div>
                )
            }
        },
        {
            Header: "เลขที่คำขอ",
            accessor: "supportNo",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        {value}
                    </div>
                )
            }
        },
        {
            Header: "เงินอุดหนุนตามประกาศ",
            accessor: "supportAnnounce",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-left">
                        {value}
                    </div>
                )
            }
        },
        {
            Header: "จำนวนเงิน (บาท)",
            accessor: a => (a.amount ? a.amount : "-"),
            Cell: ({ value }) => { return <div className="d-flex justify-content-end">{NumberWithCommas(value)}</div> }
        },
        {
            Header: "สถานะ",
            accessor: "supportStatusName",
            Cell: ({ row, value }) => {
                // console.log("row data", row)
                return (
                    <div className="">
                        {value}
                        {row.original.supportStatusId === "18" && user.roldId === "4" ? (
                            <Tippy content="รับทราบ ชอ.4">
                                <CallAcceptConsiderReport supportId={row.original.supportId} />
                            </Tippy>
                        ) : null}
                        {/* {row.original.supportStatusId === "13" && user.roldId === "3" ? (
                            <Tippy content="รับทราบ ชอ.4">
                                <CallAcceptConsiderReport supportId={row.original.supportId} />
                            </Tippy>
                        ) : null} */}
                        <FaSistrix
                            className="mx-3 style-icon"
                            onClick={() => {
                                // console.log("row.original.supportId", row.original.supportId);
                                // console.log("row.original.supportTypeId", row.original.supportTypeId);

                                openModal(row.original.supportId, row.original.supportTypeId)
                            }}
                        />
                    </div>
                )
            }
        },
    ]

    //แสดงรายการ ชอ4-7, 4-8,4-10 สำหรับ กกส
    const reportUsingMoneyColumn = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1
        },
        {
            Header: "ชื่อหน่วยงาน",
            accessor: "deptName",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        {value}
                    </div>
                )
            }
        },
        {
            Header: "สาขาอาชีพ",
            accessor: "lawOccupationName",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        {value}  {row.original.testOccupationName != null ? `สาขา ${row.original.testOccupationName}` : `โครงการ ${row.original.courseName}`}
                    </div>
                )
            }
        },
        {
            Header: "จำนวนเงิน (บาท)",
            accessor: a => (a.paymentAmount ? a.paymentAmount : "-"),
            Cell: ({ value }) => { return <div className="text-end">{NumberWithCommas(value)}</div> }
        },
        {
            Header: "สถานะ",
            accessor: "supportStatusName",
            Cell: ({ row, value }) => {
                // console.log("row", row)
                return (
                    <div className="text-start">
                        {value}
                        {/* 🔍 ปุ่มแว่นขยาย */}
                        <FaSistrix
                            className="mx-3 style-icon"
                            onClick={() => handleShowDetail(row.original)}
                        />

                        {row.original.supportStatusId == "18" ? (
                            <Tippy content="รับทราบ">
                                <CallAcceptConsiderReportUsingMoney id={row.original?.id} type={row.original?.typeReport} />
                            </Tippy>
                        ) : null}
                    </div>
                )
            }
        },
    ]

    //แสดงรายการ ชอ4-7, 4-8, 4-10 สำหรับ จนท สพร
    const reportUsingMoneyColumnOfficer = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1
        },
        {
            Header: "สาขาอาชีพ",
            accessor: "lawOccupationName",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        <div className="text-start">
                            {value}  {row.original.testOccupationName != null ? `สาขา ${row.original.testOccupationName}` : `โครงการ ${row.original.courseName}`}
                        </div>
                    </div>
                )
            }
        },
        {
            Header: "จำนวนเงิน (บาท)",
            accessor: a => (a.paymentAmount ? a.paymentAmount : "-"),
            Cell: ({ value }) => { return <div className="text-end">{NumberWithCommas(value)}</div> }
        },
        {
            Header: "สถานะ",
            accessor: "supportStatusName",
            Cell: ({ row, value }) => {
                // console.log("row supportStatusName", value)
                return (
                    <div className="text-start">
                        {value}
                    </div>
                )
            }
        },
    ]
    //แสดงรายการ ชอ4-9, 4-11 สำหรับ กกส
    const reportUsingMoneyCertAndProjectColumn = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1
        },
        {
            Header: "ชื่อหน่วยงาน",
            accessor: "deptName",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        {value}
                    </div>
                )
            }
        },
        {
            Header: "โครงการ/กิจกรรม",
            accessor: "",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        {row.original.detailContest != null ? `กิจกรรม ${row.original.detailContest}` : `โครงการ ${row.original.projectName}`}
                    </div>
                )
            }
        },
        // {
        //     Header: "จำนวนเงิน (บาท)",
        //     accessor: a => (a.paymentAmount ? a.paymentAmount : "-"),
        //     Cell: ({ value }) => { return <div className="text-end">{NumberWithCommas(value)}</div> }
        // },
        {
            Header: "สถานะ",
            accessor: "supportStatusName",
            Cell: ({ row, value }) => {
                console.log("row", row)
                return (
                    <div className="text-start">
                        {value}
                        {/* 🔍 ปุ่มแว่นขยาย */}
                        <FaSistrix
                            className="mx-3 style-icon"
                            onClick={() => handleShowDetail(row.original)}
                        />
                        {row.original.supportStatusId == "18" ? (
                            <Tippy content="รับทราบ">
                                <CallAcceptConsiderReportUsingMoney id={row.original?.id} type={row.original?.typeReport} />
                            </Tippy>
                        ) : null}
                    </div>
                )
            }
        },
    ]

    //แสดงรายการ ชอ4-9, 4-11, สำหรับ จนท สพร
    const reportUsingMoneyCertAndProjectColumnOfficer = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1
        },
        {
            Header: "สาขาอาชีพ",
            accessor: "lawOccupationName",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-start">
                        <div className="text-start">
                            {value}  {row.original.testOccupationName != null ? `สาขา ${row.original.testOccupationName}` : `โครงการ ${row.original.courseName}`}
                        </div>
                    </div>
                )
            }
        },
        {
            Header: "จำนวนเงิน (บาท)",
            accessor: a => (a.paymentAmount ? a.paymentAmount : "-"),
            Cell: ({ value }) => { return <div className="text-end">{NumberWithCommas(value)}</div> }
        },
        {
            Header: "สถานะ",
            accessor: "supportStatusName",
            Cell: ({ row, value }) => {
                // console.log("row supportStatusName", value)
                return (
                    <div className="text-start">
                        {value}
                    </div>
                )
            }
        },
    ]





    //-------------------------แบบฟอร์มโอนเงินของเจ้าหน้าที่-------------------------------------------
    const transferPromotionSubmit = async (values) => {
        let amount = parseFloat(values.amount.replace(/,/g, ''))
        let transferAmount = parseFloat(values.transferAmount.replace(/,/g, ''))
        // console.log("amount", amount);
        // console.log("transferAmount", transferAmount);
        if (transferAmount > amount) {
            Swal.fire({
                icon: "error",
                title: "",
                text: "จำนวนเงินที่โอนมีจำนวนมากกว่าจำนวนเงินที่ขอ",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
            return;
        }
        setLoading(true)
        let postData = new FormData();
        postData.append("supportId", selectedSupportId)
        Object.entries(values).forEach(([key, value]) => {
            postData.append(key, value);
        });
        try {
            let res = await fetch("/api/SupportForm/saveTransferPromotion", {
                method: "POST",
                body: postData,
            });

            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    window.location.reload();
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            // console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const validateSchema = Yup.object().shape({
        // amount:Yup.number(),
        transferDate: Yup.date().required("กรุณาเลือกวัน/เดือน/ปี ที่จ่ายเงิน"),
        transferAmount: Yup.string().required("กรุณากรอกจำนวนเงิน")
        // transferAmount: Yup.number().typeError("กรุณากรอกตัวเลข").max(Yup.ref("amount")).required("กรุณากรอกจำนวนเงินที่โอน"),
    })

    const initialValues = {
        // dataAmount:""
        roldId: user.roldId,
        amount: dataSupportId[0]?.amount ?? "",
        transferDate: "",
        transferAmount: "",
        transferSlip: ""
    }

    const FormTransferPromotion = () => {
        return (
            <Modal
                isOpen={modalTransferPromotion}
                onRequestClose={toggleModalTransferPromotion}
                style={myCustomStyles}
            >

                <div className="d-flex justify-content-between align-items-center w-100">
                    <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}>บันทึกข้อมูลรายละเอียดการจ่ายเงินช่วยเหลือหรืออุดหนุน</h3>
                    <CgClose onClick={toggleModalTransferPromotion} className="style-iconmodal" />
                </div>
                <hr />
                <Formik
                    initialValues={initialValues}
                    onSubmit={transferPromotionSubmit}
                    validationSchema={validateSchema}
                >
                    {(formik) => {
                        // console.log("formik.value", formik.values);
                        // console.log("errorr", formik.errors)
                        return (
                            <>
                                {/* <>ประจำปีงบประมาณ {budgetYear}</> */}
                                <Form className="px-5">
                                    {dataSupportId?.map((data) => (
                                        <>
                                            <div className="d-flex">
                                                <span style={{ lineHeight: "2rem" }} className="w-25 input-color">หน่วยงาน :</span>
                                                <p style={{ lineHeight: "2rem" }} className="w-100 mx-1 rounded-pill border px-3 text-center input-color">{data.deptName}</p>
                                            </div>

                                            <div className="d-flex flex-column">
                                                <span style={{ lineHeight: "2rem" }} className="input-color">เงินช่วยเหลือหรืออุดหนุนตามประกาศ :</span>
                                                <p style={{ lineHeight: "2rem" }} className="mx-1 rounded-pill border px-3 text-center input-color">{data.supportAnnounce}</p>
                                            </div>

                                            <div className="d-flex">
                                                <span style={{ lineHeight: "2rem" }} className="w-25 input-color">จำนวนเงินที่ขอ:</span>
                                                <p style={{ lineHeight: "2rem" }} className="w-100 mx-1 rounded-pill border px-3 text-center input-color">{NumberWithCommas(data.amount)} บาท</p>
                                            </div>
                                        </>


                                    ))}
                                    <FormGroup>
                                        <Label>จำนวนเงินที่{user.roldId === "4" ? "โอน" : "จ่าย"}</Label>
                                        <Field name="transferAmount">
                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    {...field}
                                                    allowLeadingZeros
                                                    thousandSeparator=","
                                                    decimalScale={2}
                                                    isNumericString={true}
                                                    displayType="number"
                                                    value={values.trainAmountLimit}
                                                    format={(value) => value.toLocaleString()}
                                                    onValueChange={(values, sourceInfo) => {
                                                        setFieldValue(field.name, Number(values.value.replace(",", "")))
                                                    }}
                                                    customInput={CustomInputNumeric}
                                                    className={meta.errors ? "input-error" : ""}
                                                />

                                            )}
                                        </Field>
                                        {/* <Input
                                            type="text"
                                            className={
                                                formik.touched.transferAmount && formik.errors.transferAmount
                                                    ? "input-error rounded-pill text-center input-color"
                                                    : "rounded-pill text-center input-color"
                                            }
                                            name="transferAmount"
                                            id="transferAmount"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.transferAmount}
                                        /> */}
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>วัน/เดือน/ปี ที่จ่ายเงิน</Label>
                                        <Field name="transferDate">
                                            {({ field, form }) => {

                                                return (
                                                    <DatePicker
                                                        selected={field.value ? new Date(field.value) : null}
                                                        locale="th-buddhist"
                                                        showIcon
                                                        calendarClassName="thai-buddhist"
                                                        dateFormat="dd MMMM yyyy"
                                                        value={ConvertDateToThaiBuddhist(field.value)}
                                                        // minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                                                        isClearable={true}
                                                        placeholderText="กรุณาเลือก"
                                                        renderCustomHeader={RenderCustomHeader}
                                                        onChange={(date) => {
                                                            form.setFieldValue(field.name, ConvertDateFormat(date))
                                                        }}
                                                        customInput={
                                                            <Input
                                                                type="text"
                                                                className={
                                                                    formik.touched.transferDate && formik.errors.transferDate
                                                                        ? "input-error rounded-pill text-center input-color"
                                                                        : "rounded-pill text-center input-color"
                                                                }
                                                                value={ConvertDateToThaiBuddhist(field.value)}
                                                                onChange={() => { }}
                                                                onBlur={field.onBlur}
                                                            />
                                                        }
                                                    />
                                                )
                                            }}
                                        </Field>
                                    </FormGroup>
                                    {user.roldId !== "3" ? (
                                        <FormGroup>
                                            <Label>เอกสารอื่นๆ (ถ้ามี)</Label>
                                            <Input
                                                type="file"
                                                className="rounded-pill text-center input-color"
                                                name="transferSlip"
                                                id="transferSlip"
                                                onChange={(e) => {
                                                    formik.setFieldValue("transferSlip", e.target.files[0])
                                                }}
                                            />
                                        </FormGroup>
                                    ) : <></>}

                                    <div className="d-flex justify-content-center align-items-center">
                                        <button className="btn-blue w-25 mx-1" type="submit">บันทึก</button>
                                        <button
                                            onClick={() => { toggleModalTransferPromotion() }}
                                            className="mx-1 btn-red w-25"
                                            type="button"
                                        >
                                            ยกเลิก
                                        </button>
                                    </div>

                                </Form>
                            </>
                        )
                    }}

                </Formik>

            </Modal>
        )
    }
    //แบบฟอร์มโอนเงินของเจ้าหน้าที่
    const showFormTransfer = async (supportId) => {
        let postData = new FormData();
        postData.append("supportId", supportId);
        try {
            let res = await fetch("/api/Support/detailsupporthelp", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();
            // console.log("dataDataenum2", data.dataenum);
            setDataSupportId(data.dataenum);
        } catch (e) {
            // console.log("err =>" + e);
        } finally {
            toggleModalTransferPromotion()
            setSelectedSupportId(supportId)
        }
    }

    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        const currentMenu = JSON.parse(localStorage.getItem("currentMenu"));
        if (currentMenu != null) {
            setTabIndex(currentMenu)
        }
    }, [])
    // console.log("tabIndex", tabIndex);

    if (loading) { return <Loading /> }
    return (
        <Container className="mt-4 mb-2">
            <Tabs
                selectedIndex={tabIndex ?? 0}
                onSelect={(index) => {
                    setTabIndex(index)
                    localStorage.setItem("currentMenu", JSON.stringify(index))
                }}
            >
                <TabList className="d-flex align-items-center justify-content-center">
                    <Tab >คำขอรับเงินช่วยเหลือหรืออุดหนุน</Tab>
                    {user.roldId !== "4" ? <Tab>คำขอรับความเห็นชอบหลักสูตรการฝึกอบรมเพื่อสร้างสรรค์นวัตกรรม</Tab> : null}
                    {/* {user.roldId === "3" || user.roldId === "4" ? <Tab>แบบรายงานการดำเนินการ (ชอ.3, ชอ.3-1, ชอ.3-2)</Tab> : null} */}
                    <Tab>แบบรายงานการดำเนินการ (ชอ.3, ชอ.3-1, ชอ.3-2)</Tab>
                    {user.roldId === "3" || user.roldId === "4" ? <Tab>แบบรายงานผลการพิจารณาอนุมัติ (ชอ.4)</Tab> : null}
                    {user.roldId === "3" || user.roldId === "4" ? <Tab>แบบรายงานผลการพิจารณาอนุมัติ (ชอ.4-7, 4-8, 4-10)</Tab> : null}
                    {user.roldId === "3" || user.roldId === "4" ? <Tab>แบบรายงานผลการพิจารณาอนุมัติ (ชอ.4-9, 4-11)</Tab> : null}

                </TabList>
                <TabPanel>
                    <CreateTableComponent
                        column={ShowInfoSupportByUsers()}
                        dataInput={dataSupport}
                        FormInput={FormButton}
                        showEntrie={true}
                        showPage={true}
                    />
                </TabPanel>
                {user.roldId !== "4" ?
                    <TabPanel>
                        <CreateTableComponent
                            column={ShowInfoInnovationByUsers()}
                            dataInput={dataInnovation}
                            FormInput={FormInnovationButton}
                            showEntrie={true}
                            showPage={true}
                        />
                    </TabPanel>
                    : null}
                {/* {user.roldId === "3" || user.roldId === "4" ?
                    <TabPanel>
                        <CreateTableComponent
                            column={ShowInfoAssessmentByUsers()}
                            dataInput={dataAssessment}
                            FormInput={FormButton}
                            showEntrie={true}
                            showPage={true}
                        />
                    </TabPanel>
                    : null} */}
                <TabPanel>
                    <CreateTableComponent
                        column={ShowInfoAssessmentByUsers()}
                        dataInput={dataAssessment}
                        // FormInput={FormButton}
                        showEntrie={true}
                        showPage={true}
                    />
                </TabPanel>
                {user.roldId === "3" || user.roldId === "4" ?
                    <TabPanel>
                        <CreateTableComponent
                            column={considerResultReportColumn}
                            dataInput={considerResultReport}
                            FormInput={FormInnovationButton}
                            showEntrie={true}
                            showPage={true}
                        />
                    </TabPanel>
                    : null}
                {user.roldId === "3" || user.roldId === "4" ?
                    <TabPanel>
                        <CreateTableComponent
                            column={user.roldId === "4" ? reportUsingMoneyColumn : reportUsingMoneyColumnOfficer}
                            dataInput={reportUsingMoney}
                            // FormInput={FormButton}
                            showEntrie={true}
                            showPage={true}
                        />
                    </TabPanel>
                    : null}
                {user.roldId === "3" || user.roldId === "4" ?
                    <TabPanel>
                        <CreateTableComponent
                            column={user.roldId === "4" ? reportUsingMoneyCertAndProjectColumn : reportUsingMoneyCertAndProjectColumnOfficer}
                            dataInput={certAndProjectReportUsingMoney}
                            // FormInput={FormButton}
                            showEntrie={true}
                            showPage={true}
                        />
                    </TabPanel>
                    : null}
            </Tabs>

            <ListFormForSelect />
            <FormTransferPromotion />
            <ModalExportSupportAnnounce9 />
            <ShowGetRemark />
            <SupportDetailModal
                isOpen={open}
                toggle={() => setOpen(false)}
                supportId={supportId}
                supportTypeId={supportTypeId}
            />
            <ReportUsingMoneyDetailModal
                isOpen={modalOpen}
                toggle={toggleModal}
                data={selectedRow}
            />



            <div class="boxes-tn">
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div> <div></div>
                <div></div>
            </div>
        </Container>



    )
}
